require('./expensesByCategoryFilter.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const moment = require('moment');

// @ helpers
const { FormattedText } = require('core/i18n').i18n;

// @ commons
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const DateFilter = require('components/commons/dateFilter/dateFilter');
const OKModal = require('components/commons/OKModal/OKModal');

// @ constants
const DATE_FILTER_MIN_DATE_LIMIT = moment().startOf('day').subtract(2, 'years');

class ExpensesByCategoryFilter extends React.Component {

    constructor(props) {
        super(props);

        const { immFilter } = props;

        this.state = {
            selected: immFilter.getIn(['date', 'selected']),
            dateFrom: immFilter.getIn(['date', 'from']),
            dateTo: immFilter.getIn(['date', 'to'])
        };

        this.handleSubmitFilters = this.handleSubmitFilters.bind(this);
        this.handleChangeDateMin = this.handleChangeDateMin.bind(this);
        this.handleChangeDateMax = this.handleChangeDateMax.bind(this);
        this.handleChangeDateSelected = this.handleChangeDateSelected.bind(this);
    }

    handleSubmitFilters() {
        const { setFilter, onCloseClick } = this.props;
        const { dateFrom, dateTo, selected } = this.state;

        setFilter({
            date: {
                isActive: selected !== 'None',
                from: dateFrom,
                to: dateTo,
                selected: selected
            }
        });

        onCloseClick();
    }

    handleChangeDateMin(dateFrom) {
        this.setState({
            dateFrom
        });
    }

    handleChangeDateMax(dateTo) {
        this.setState({
            dateTo
        });
    }

    handleChangeDateSelected(selected) {
        this.setState({
            selected
        });
    }

    render() {
        const { isOpen, onCloseClick, immFilter } = this.props;
        const tooltipTarget = (
            <span>
                <FormattedText
                    className="expenses-by-category-filter__title"
                    value="accounts-filterMovements" format="firstUppercase"
                />
            </span>
        );

        const contentModal = (
            <React.Fragment>
                <OKTooltip
                    content="accountMovements-filterTooltip"
                    offset={[15, 0]}
                    placement="right"
                    target={tooltipTarget}
                />
                <div className="modal-scroll-container">
                    <DateFilter
                        immFilter={immFilter.get('date')}
                        onChangeMin={this.handleChangeDateMin}
                        onChangeMax={this.handleChangeDateMax}
                        onChangeSelected={this.handleChangeDateSelected}
                        minDate={DATE_FILTER_MIN_DATE_LIMIT}
                        showTwoYears={false}
                    />

                </div>
            </React.Fragment>
        );

        return (
            <OKModal
                content={contentModal}
                isOpen={isOpen}
                onCloseCallback={onCloseClick}
                type="filter"
                footerType="navigation"
                primaryButtonText="filterDate-apply"
                onPrimaryButtonClick={this.handleSubmitFilters}
                secondaryButtonCallback={onCloseClick}
                secondaryButtonText="filterDate-cancel"
            />
        )
    }
}

ExpensesByCategoryFilter.propTypes = {
    immFilter: PropTypes.object,
    isOpen: PropTypes.bool,
    onCloseClick: PropTypes.func.isRequired,
    setFilter: PropTypes.func,
}

module.exports = ExpensesByCategoryFilter;

